import { PostEditorReducerFunction, PostEditorSetGoogleButton } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { GroupPostAttributesType } from '../../../../models/post-editor';

export const setGoogleButtonReducer: PostEditorReducerFunction<PostEditorSetGoogleButton['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { customizeIndex, postGroupIndex, googleCallToAction } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable<GroupPostAttributesType>(currentPost, {
      content: {
        link: {
          $apply: currentLink => (currentLink ? { ...currentLink, googleCallToAction } : currentLink)
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'content', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, ['checkLinksPresent']);
};
